export enum WebLink {
  tos = 'https://useclip.com/tos',
  privacyPolicy = 'https://useclip.com/privacy',
  contact = 'https://useclip.com/contact',
  bookAnOnboardingCall = 'https://calendly.com/clip-demo/30min',
}
